<script>
  /**
   * I needed a quick way to execute jqueryish code with a Svelte store's data.
   * The component itself doesn't render any UI in place, but needs to mount to fire the function with the Svelte store's data.
   */
  export let store = undefined

  export let dataFunction = (data) => {
    console.log('By default, all this will do is log the data for the store you pass in. You need to pass in a function at this prop that takes a 1 param [data] and does something with it.', data)
  }

 $: dataFunction($store)
</script>